import { render, staticRenderFns } from "./CallForBids.vue?vue&type=template&id=bcb56daa&scoped=true"
import script from "./CallForBids.vue?vue&type=script&lang=js"
export * from "./CallForBids.vue?vue&type=script&lang=js"
import style0 from "./CallForBids.vue?vue&type=style&index=0&id=bcb56daa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb56daa",
  null
  
)

export default component.exports